import {
  Avatar,
  Box,
  Button,
  Dialog,
  Typography,
  useTheme,
  CardMedia,
} from "@mui/material"
import size from "lodash/size"
import { StoreIcon } from "components/icons"
import { HorizontalScrollPane } from "components/HorizontalScrollPane/HorizontalScrollPane"
import { useTranslation } from "providers/i18n"
import { FeatureLabel } from "./FeatureLabel"
import { CloseIconButton } from "components/Button/CloseIconButton"
import { QRCode } from "components/QRCode"
import { CloseCircleOutlineIcon } from "../../icons"

export const KioskFeatureDialog = ({
  open,
  onClose,
  directionButtonProps = {},
  loading = true,
  data = {},
  onNavigate = () => {},
  ...props
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const {
    logo,
    category,
    name,
    hours,
    gallery,
    description,
    location,
    placeDetailMobileUrl,
  } = data
  const galleryImageLength = size(gallery)

  const styleOverrides =
    theme.components[`AppKioskFeatureDialog`]?.styleOverrides || {}
  const {
    root,
    dialog,
    primarySection,
    secondarySection,
    header,
    content,
    avatar,
    imageListContainer,
    imageList,
    imageItem,
    actionContainer,
    listContainer,
    qrCodeContainer,
    closeButton,
  } = styleOverrides

  return (
    <Dialog sx={dialog} open={open} onClose={onClose} {...props}>
      <Box sx={root}>
        <CloseIconButton
          sx={closeButton}
          icon={<CloseCircleOutlineIcon fontSize="inherit" />}
          onClick={onClose}
          size="large"
        />
        <Box sx={primarySection}>
          <Box sx={header}>
            <Avatar variant="circular-logo" sx={avatar} src={logo}>
              <StoreIcon />
            </Avatar>
            <Typography gutterBottom variant="h5">
              {t(name, {
                ns: "imdf",
              })}
            </Typography>
          </Box>
          {description && (
            <Box sx={content}>
              <Typography variant="body2" color="text.secondary">
                {t(description)}
              </Typography>
            </Box>
          )}
          {galleryImageLength > 0 && (
            <Box sx={imageListContainer}>
              <HorizontalScrollPane
                sx={{
                  ...imageList,
                  justifyContent:
                    galleryImageLength <= 2 ? "center" : "flex-start",
                }}
              >
                {gallery.map(({ name, url }, idx) => (
                  <CardMedia
                    key={`${name}-${idx}`}
                    sx={imageItem}
                    image={url}
                    title={name}
                  />
                ))}
              </HorizontalScrollPane>
            </Box>
          )}
          <Box sx={actionContainer}>
            <Button
              variant="contained"
              onClick={onNavigate}
              {...directionButtonProps}
            >
              {t("Get direction")}
            </Button>
          </Box>
        </Box>
        <Box sx={secondarySection}>
          <Box sx={listContainer}>
            <FeatureLabel label={t("Location")} value={t(location)} />
            <FeatureLabel
              label={t("Category")}
              value={t(category, { ns: "imdf" })}
            />
            <FeatureLabel label={t("Operation Time")} value={hours || "-"} />
            {placeDetailMobileUrl && (
              <QRCode
                sx={qrCodeContainer}
                url={placeDetailMobileUrl}
                caption={t("Send to mobile")}
              />
            )}
          </Box>
        </Box>
      </Box>
    </Dialog>
  )
}
